module.exports = __webpack_public_path__ + "static/media/cameraAllow.333e9cdc.png";